export interface ProjectVersusImage {
    id: number;
    projectId: number;
    type: string;
    url: string;
    width: number | null;
    height: number | null;
}
